<template>
      <div no-body class="lku-lookup-sales"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblGrp"
          responsive
          small
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.pagelimit"
          :filter="filter"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          @row-clicked="selectItem"
        >
        </b-table>
        <b-row>
          <b-col cols="6">{{showingLabel}}</b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.pagelimit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
</template>
<style lang="scss">
  .lku-coa {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          // {
          //   key: "kode",
          //   label: "Code",
          //   sortable: true
          // },
          {
            key: "NamaSale",
            label: "Name",
            sortable: true
          },
          {
            key: "saleCrCode",
            label: "GL Account Code",
            sortable: true
          },
          {
            key: "saleCrName",
            label: "GL Account Name",
            sortable: true
          },
        //   {
        //     key: "hrg_agen_konsi",
        //     label: "Harga Konsinyasi",
        //     sortable: true
        //   },
      ],
      items:[],
      tblData: {
        tablename:'salegroup',
        page: 1,
        limit: 1000,
        pagelimit: 15,
        total: 0,
        sortBy: 'kode',
        sortDesc: false
      },
      filter:null
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, total,pagelimit } = tblData;

      const val1 = (page - 1) * pagelimit + 1;
      const val2 = page * pagelimit < total ? page * pagelimit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // let str='';
      // if (this.filter){
      //   str = 'NamaSale=%' + encodeURIComponent(this.filter)+'%&saleCrCode=%' + encodeURIComponent(this.filter)+'%';
      // }
      // this.tblData.customQuery=str;

      this.items=await crud.list(this.tblData);
      const item = this.items.find(p => p.value=='N/A');
      if (!(item)) {
          this.items.push({kode:'N/A', NamaSale:'Not Applicable', isActive:'1', isdeleted:'0'});
      }

      return this.items;      

    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      // this.$refs.tblGrp.refresh();
      this.data();
    }
  }
};
</script>
